import React from 'react'
import { Link } from 'react-router-dom'
import probnr from '../../../../assets/img/pro_mn.webp'

function Wpw() {
  return (
    <section className='hmslder-sec abt-sec'>
        <div className='breadcrumbs'>
            <div className='container'>
             <ul>
               <li><Link to='/'>Home</Link> </li> 
               <li>Our Projects</li>   
             </ul> 
             </div> 
        </div>
        <div className='container'>
           <div className='hmslder-txt'>
              <h2>Real-world success stories that <span>showcase our expertise</span> in action.</h2>
              <p>Our projects show how strategy and execution come together to create impact. We partner with organisations to design, develop, and launch bespoke digital experiences focused on results. Each engagement combines insight, iteration, and clear metrics to solve specific challenges. Browse case studies that highlight our process, outcomes, and the tangible value delivered.
              </p>
            </div> 
           <div className='hmslder-img'>
            <img src={probnr} alt='' loading="lazy" />
            </div>  
        </div>
    </section>
  )
}

export default Wpw
